<button class="common-btn" [ngClass]="color+' '+ size" [class.outline]="outline">
    <ng-content></ng-content>
</button>